import { render, staticRenderFns } from "./RequisitionForm.vue?vue&type=template&id=4ed45cd0&scoped=true&"
import script from "./RequisitionForm.vue?vue&type=script&lang=js&"
export * from "./RequisitionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed45cd0",
  null
  
)

export default component.exports